import gsap from "gsap";

(function ($) {
    $(document).ready(function () {

        const section = $(".section-animated-images");

        const mouseMoveFunc = (e) => {

            if ($(window).width() <= 1400) {
                return
            }

            let relativeXPosition = (e.pageX - section.offset().left);
            let relativeYPosition = (e.pageY - section.offset().top);

            section.find(".animated-image").each((index, el) => {
                let itemIndex = index + 1;

                gsap.to($(el), {
                    duration: .5,
                    x: relativeXPosition / (itemIndex * 25),
                    y: relativeYPosition / (itemIndex * 10),
                    overwrite: true,
                });
            })
        }

        const mouseLeave = () => {
            gsap.to(".section-animated-images .animated-image", {duration: .6, x: 0, y: 0, overwrite: true});
        }

        section.on("mousemove", mouseMoveFunc);
        section.on("mouseleave", mouseLeave);

    })
})(jQuery);